import { derived } from 'svelte/store'

import fetchStore from '../utilities/fetchStore'

const regex = /\$|\,/g

import { edumed, mcat, gender, gpa, tuition, meandebtload, stepmeanscores, uscanadascores } from '../dataPromisesMenu'

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    edumed: edumed,
    gender: gender,
    gpa: gpa,
    mcat: mcat,
    meandebtload: meandebtload,
    stepmeanscores: stepmeanscores,
    tuition: tuition,
    uscanadascores: uscanadascores,
  }
  
  const [data, loading, error] = fetchStore(dataCalls)

  const edumedDerived = derived(data, ($data)=>{
    if($data.edumed) {
      return Object.values($data.edumed)[0]
    } else {
      return 0
    }
  }, 0)

  const gpaDerived = derived(data, ($data)=>{
    if($data.gpa) {
      return Object.values($data.gpa)[0]
    } else {
      return 0
    }
  }, 0)

  const mcatDerived = derived(data, ($data)=>{
    if($data.mcat) {
      return Object.values($data.mcat)[0]
    } else {
      return 0
    }
  }, 0)

  const meandebtloadDerived = derived(data, ($data)=>{
    if($data.meandebtload) {
      return Object.entries($data.meandebtload)
    } else {
      return []
    }
  }, [])

  const stepmeanscoresDerived = derived(data, ($data)=>{
    if($data.stepmeanscores) {
      return Object.entries($data.stepmeanscores)
    } else {
      return []
    }
  }, [])

  const tuitionDerived = derived(data, ($data)=>{
    if($data.tuition) {
      return Object.entries($data.tuition)
    } else {
      return []
    }
  }, [])

  const uscanadascoresDerived = derived(data, ($data)=>{
    if($data.uscanadascores) {
      return Object.entries($data.uscanadascores)
    } else {
      return []
    }
  }, [])

  const genderDerived = derived(data, ($data)=>{
    if($data.gender) {
      return Object.entries($data.gender)
    } else {
      return []
    }
  }, [])
  
  return [
    data, 
    loading, 
    error,

    edumedDerived,
    genderDerived,
    gpaDerived,
    mcatDerived,
    meandebtloadDerived,
    stepmeanscoresDerived,
    tuitionDerived,
    uscanadascoresDerived
  ]
}